import GenericContentSearch from './helpers/GenericContentSearch';

export default GenericContentSearch({
  search: {
    name: 'Attribute Sets',
    type: 'AttributeSet',
    currentLanguageOnly: true,
  },
});
